import React from "react";
import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";

const ConfirmDeleteModal = ({ isVisible, onClose, handleConfirm }) => {
  return (
    <CModal scrollable visible={isVisible} onClose={onClose} backdrop="static">
      <CModalHeader>
        <CModalTitle>
          <span>Delete</span>
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div>
          <span style={{ fontSize: "20px" }}>
            Are you sure you want to delete?
          </span>
        </div>
        <div className="mt-2 ms-3 text-center">
          <button
            type="button"
            className="btn btn-danger btn-sm text-white"
            onClick={handleConfirm}
            style={{ width: "50px", height: "35px", fontSize: "15px" }}
          >
            Yes
          </button>
          <button
            className="ms-3 btn btn-success btn-sm text-white"
            onClick={onClose}
            style={{ width: "50px", height: "35px", fontSize: "15px" }}
          >
            No
          </button>
        </div>
      </CModalBody>
    </CModal>
  );
};

export default ConfirmDeleteModal;
